// mock/index.js
import Mock from "mockjs";

// 模拟的 JSON 数据
const mockMenuData = [
  {
    id: 1,
    parentId: 0,
    mediaTitle: "湘雅医院临床病理数字化教学平台",
    mediaList: [
      {
        id: 101,
        parentId: 1,
        label: "湘雅病理融媒体平台",
        // path: "http://kind-knowledge.top:8002/video.phone",
        path: "http://kind-knowledge.top:8002",
        imgUrl: "视频融媒体.jpg",
      },
      {
        id: 102,
        parentId: 1,
        label: "湘雅病理数字切片中心",
        path: "http://kind-knowledge.top:81/digitalCliceCenter",
        imgUrl: "数字切片库.jpg",
      },
      {
        id: 110,
        parentId: 1,
        label: "湘雅病理数字切片中心（新）",
        path: "http://kind-knowledge.top:7007",
        imgUrl: "数字切片库.jpg",
      },
      {
        id: 103,
        parentId: 1,
        label: "湘雅病理晨读切片中心",
        path: "http://kind-knowledge.top:81/morningSliceCenter",
        imgUrl: "晨读切片库.jpg",
      },
      {
        id: 104,
        parentId: 1,
        label: "湘雅病理资料文件库",
        path: "http://kind-knowledge.top:81/pdf/index.html",
        imgUrl: "资料文件库.jpg",
      },
      {
        id: 105,
        parentId: 1,
        label: "湘雅病理教育考试平台",
        path: "http://kind-knowledge.top:8001/student/#/index",
        imgUrl: "教育考试平台.jpg",
      },
    ],
  },
  {
    id: 7,
    parentId: 0,
    mediaTitle: "中南大学湘雅二医院情景病理数据库",
    mediaList: [
      {
        id: 701,
        parentId: 7,
        label: "湘雅二医院融媒体平台",
        path: "http://kind-knowledge.top:8002?hospitalCode=YY7739005&appKey=APP7225001",
        imgUrl: "视频融媒体.jpg",
      },
      {
        id: 702,
        parentId: 7,
        label: "湘雅二医院数字切片库",
        path: "http://kind-knowledge.top:7007?hospitalCode=YY7739005&appKey=APP4625001",
        imgUrl: "数字切片库.jpg",
      },
    ],
  },
  {
    id: 8,
    parentId: 0,
    mediaTitle: "湖南壹路康宁生物科技有限公司",
    mediaList: [
      {
        id: 801,
        parentId: 8,
        label: "壹路康宁融媒体平台",
        path: "http://kind-knowledge.top:8002?hospitalCode=YY4750001&appKey=APP7225001",
        imgUrl: "视频融媒体.jpg",
      },
    ],
  },
  {
    id: 2,
    parentId: 0,
    mediaTitle: "科技融媒体",
    mediaList: [
      {
        id: 201,
        parentId: 2,
        label: "科技融媒体平台",
        path: "http://kind-knowledge.cn:8001/video",
        imgUrl: "huaHouMedia.jpg",
      },
    ],
  },
  {
    id: 3,
    parentId: 0,
    mediaTitle: "MDT 会议",
    mediaList: [
      {
        id: 3001,
        parentId: 3,
        label: "进入 MDT 会议",
        imgUrl: "xiangTanSlice.jpg",
        // path: "https://kindknowledge.top:10443",
        path: "https://kindknowledge.top",
      },
    ],
    docutIntrodtLink: "https://mp.weixin.qq.com/s/q7Q4vuSAsKM3WbwmVSELXA",
  },
  {
    id: 5,
    parentId: 0,
    mediaTitle: "远程会诊",
    mediaList: [
      {
        id: 501,
        parentId: 5,
        label: "长沙经开医院远程会诊",
        imgUrl: "xiangYaDraw.jpg",
        path: "http://kind-knowledge.top:1011/#/login",
      },
    ],
    docutIntrodtLink: "https://mp.weixin.qq.com/s/_zDLcGlfRR1Zd_jJWfssfQ",
  },
  {
    id: 6,
    parentId: 0,
    mediaTitle: "教学平台文件库",
    mediaList: [
      {
        id: 601,
        parentId: 6,
        label: "临床病理住院医师规范化培训教学平台的建设与应用",
        imgUrl: "资料文件库.jpg",
        path: "http://kind-knowledge.top:5057/files/pdf/20260518/%E4%B8%B4%E5%BA%8A%E7%97%85%E7%90%86%E4%BD%8F%E9%99%A2%E5%8C%BB%E5%B8%88%E8%A7%84%E8%8C%83%E5%8C%96%E5%9F%B9%E8%AE%AD%E6%95%99%E5%AD%A6%E5%B9%B3%E5%8F%B0%E7%9A%84%E5%BB%BA%E8%AE%BE%E4%B8%8E%E5%BA%94%E7%94%A8(1).pdf",
      },
    ],
    docutIntrodtLink: "https://mp.weixin.qq.com/s/_zDLcGlfRR1Zd_jJWfssfQ",
  },
];

// 拦截接口请求
// Mock.mock("/api/getMenuList", "get", (options) => {
//     console.log(options)
//   return {
//     code: 200,
//     message: "success",
//     data: mockMenuData,
//   };
// });

// 正则匹配所有/api/getMenuList开头的请求（含参数）
Mock.mock(/^\/api\/getMenuList/, "get", (options) => {
  console.log("/api/getMenuList", options);
  return {
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    },
    code: 200,
    message: "success",
    data: mockMenuData,
  };
});
